import { array, number, string, struct } from 'io-ts/Decoder';

import { Id as TransactionId } from '../../../../transaction/Id';
import { Area } from '../../../../ui/geometry/Area';

export const Request = struct({
	text: string,
	areas: array(Area),
	textDifferenceIds: array(number),
	transactionIds: array(TransactionId),
});
